import { getAssetsUrl } from 'helpers/getAssetsUrl'

export const ONBOARDING_BRIEF_QUIZ_CONTENT = {
  src: getAssetsUrl('constants/briefQuizImageDefault.jpg'),
  quote: 'Self-reflection is the school of wisdom.',
  quoteAuthor: '- Baltasar Gracia',
}

export const IS_QUIZ_COMPLETED = 'isQuizCompleted'
